var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"skip-link",attrs:{"href":_vm.target}},[_vm._v("跳到主要內容")])}
var staticRenderFns = []

export { render, staticRenderFns }